import React, { useEffect } from "react";
import {useState }from "react";
import { PDFViewer } from "@progress/kendo-react-pdf-viewer";
import { ParamSelection } from "../shared/paramSelection";
import { reportService } from "../../services/api/report.service"; 
import { alertService } from '../../services/helpers/alert.service';
import { utils } from "../../services/helpers/utils";
import { useLocation } from "react-router-dom";


export const Raport = ({ title, haveLocation }) => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search)
    const param = searchParams.get("q");

    if (haveLocation === undefined) {
        haveLocation = false;
    }

    useEffect(() => {
        setVisible(true);
    }, [title])

    useEffect(() => {
        if (param !== null) {
            setVisible(true);
        }

    }, [param])


    const [data, setData] = React.useState("");
    const [visible, setVisible] = useState( true);
    const toggleDialog = () => {
        setVisible(false);
    }

    const verifyParams = (title, type, data) => {

        if (data.partener == null || data.partener == 0) {
            if (title == "Consultatii MM nefinalizate") {
                if (data.deladata == null) {
                    alertService.error("Campul De la data este obligatoriu!");
                    return false
                }

                let tmpDataS = new Date(data.deladata);
                let tmpDataE = data.ladata == null ? new Date() : new Date(data.ladata);
                tmpDataS.setMonth(tmpDataS.getMonth() + 6)
                if (tmpDataS < tmpDataE) {
                    alertService.error("Perioada de timp nu poate depasi 6 luni!");
                    return false
                }

            }
        }
        return true;
    }


    const runRaport = (title, type, data) => {

        const vefiry = verifyParams(title, type, data)

        if (!vefiry) {
            return;
        }

        switch (title) {
            case "Consultatii nefinalizate":
                if (type === "PDF") {
                    reportService.RaportConsultatiiNefinalizate(data).then((response) => {
                        setData(response);
                    });
                }
                else {
                    reportService.ExportConsultatiiNefinalizate(data).then((response) => {
                        setData(null)
                        utils.downloadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                    });
                }
                break;

            case "Consultatii MM nefinalizate":
                if (type === "PDF") {
                    reportService.RaportConsultatiiMMNefinalizate(data).then((response) => {
                        setData(response);
                    });
                }
                else {
                    reportService.ExportConsultatiiMMNefinalizate(data).then((response) => {
                        setData(null)
                        utils.downloadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                    });
                }
                break;

            case "Servicii respinse":
                if (type === "PDF") {
                    reportService.RaportServiciiRespinse(data).then((response) => {
                        setData(response);
                    });
                }
                else {
                    reportService.ExportServiciiRespinse(data).then((response) => {
                        setData(null)
                        utils.downloadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                    });
                }
                break;

            case "Servicii medicale pentru facturare":
                if (type === "PDF") {
                    reportService.RaportServiciiMedicalePentruFacturare(data).then((response) => {
                        setData(response);
                    });
                }
                else {
                    reportService.ExportServiciiMedicalePentruFacturare(data).then((response) => {
                        setData(null)
                        utils.downloadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                    });
                }
                break;

            case "Fise MM pentru facturare":
                if (type === "PDF") {
                    reportService.RaportFiseMMPentruFacturare(data).then((response) => {
                        setData(response);
                    });
                }
                else {
                    reportService.ExportFiseMMPentruFacturare(data).then((response) => {
                        setData(null)
                        utils.downloadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                    });
                }
                break;

            case "Servicii medicale prestate":
                if (type === "PDF") {
                    reportService.RaportServiciiMedicalePrestate(data).then((response) => {
                        setData(response);
                    });
                }
                else {
                    reportService.ExportServiciiMedicalePrestate(data).then((response) => {
                        setData(null)
                        utils.downloadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                    });
                }
                break;

        }
        setVisible(false);

    }

    return (
        <div>
            <h2>{title}</h2>
            {data && < PDFViewer data={data}></PDFViewer>}
            <ParamSelection
                runRaport={runRaport}
                title={title}
                haveLocation={haveLocation}
                visible={visible}
                toggleDialog={toggleDialog} />
        </div>
    );
};
